/*!
  Cooph JS from custom modifcations
  by Danish Zahur (danish.zahur@zooom.com)
  Access unminified JS in assets/cooph-custom.js
*/


/* ==== Product detail page ==== */

var productImagesOpenAll =  document.querySelector('div[data-product-images-all-open]');
if (productImagesOpenAll != null) {
  var productImagesSlider =  document.querySelector('div[data-product-images]');

  // Function to hide and unhide selected varient images.
  var showVarientImages = function() { 
    var searchAlt = productImagesSlider.querySelector('.is-selected img').dataset.photoVarient.split('_') || [];
    if (searchAlt !== undefined && searchAlt !== null) {
      productImagesOpenAll.querySelectorAll('.grid__item').forEach(function(imgWrap) {
        var alt = imgWrap.querySelector('img').dataset.photoVarient;
        
        if (!(alt === undefined || alt === null)) {
          var altParts = alt.split('-');
          alt = altParts[0];
        }
        
        if (searchAlt.length == 0 || searchAlt.includes(alt) || alt === searchAlt.join('_')) {
          imgWrap.classList.remove('hide');
        }
        else {
          imgWrap.classList.add('hide');
        }
      });
    }
  }

  window.addEventListener("load", function() {
    
    var variantToChangeImage = document.querySelectorAll('.variant-wrapper input[name*=Color], .variant-wrapper input[name=Ending], .variant-wrapper input[name=Bundle]');
    productImagesOpenAll.querySelectorAll('.product-main-slide').forEach(function(imgWrap) {
      // Set class to display images in 2 grid colomns
      imgWrap.setAttribute('class', 'grid__item medium-up--three-sixths' + (variantToChangeImage.length ? ' hide' : ''));

      // Handel image zoom using theme image slider
      var photosZoom = imgWrap.querySelector('.js-photoswipe__zoom');
      if (photosZoom != null) {
        imgWrap.querySelector('.js-photoswipe__zoom').addEventListener('click', function(event) {
          var gridItem  = event.target.closest('.grid__item');
          //var i = parseInt(gridItem.dataset.index) + 1;
          var firstVariantItem = gridItem.closest('.grid').querySelector('.grid__item:not([class*="hide"])');
          var i = parseInt(gridItem.dataset.index) - parseInt(firstVariantItem.dataset.index) + 1;
          
          productImagesSlider.querySelector('.flickity-page-dots li:nth-of-type('+ i +')').click();
          productImagesSlider.querySelector('.js-photoswipe__zoom').click();
        });
      }
      
      // Handel video
      var photosVideo = imgWrap.querySelector('video');
      if (photosVideo != null) {
        photosVideo.play();
      }
      
      imgWrap.querySelector('img').addEventListener('load', function(event) {
        event.target.parentElement.style.backgroundColor = "transparent";
      });
    });
    productImagesOpenAll.querySelector('.product__main-photos-all-open').classList.remove('hide');

    if (variantToChangeImage.length) {
      variantToChangeImage.forEach(function(variantInput, index, arr) {
        variantInput.addEventListener('click', function(event) {
          setTimeout(showVarientImages, 500);
        });
      });
      setTimeout(showVarientImages, 500);
    }
    
    document.querySelectorAll('div[data-product-images-all-open] img[alt*="-big"]').forEach(function(img) {
      var gridItem = img.closest('.grid__item.medium-up--three-sixths');
      gridItem.classList.add('medium-up--six-sixths');
      gridItem.classList.remove('medium-up--three-sixths');
    })
  });
}

function intiColorVariantSelector(parentElement) {
  
  var colorVariantSelector = parentElement.querySelector('.variant-input-wrap[data-handle="color"]');
  if (colorVariantSelector != null && colorVariantSelector.classList.contains('flickity-enabled') == false) {
    
    var colorVariantInput = colorVariantSelector.querySelectorAll('.variant-input:not(.variant-hide)');
    if (colorVariantSelector.clientWidth < (colorVariantInput.length * colorVariantInput[0].offsetWidth)) {
      var colorVariantSelectorSlider = new Flickity(colorVariantSelector,
        {
          wrapAround: true,
          pageDots: false,
          freeScroll: true,
          // groupCells: true,
          on: {
            ready: function() {
              var slider = this;
              slider.element.querySelectorAll('input').forEach(function(variantInput, index) {
                if(variantInput.checked) 
                {
                  slider.select(++index);
                }
              });
            }
          }
        }
      );

      window.addEventListener('resize', function(event) {
        colorVariantSelectorSlider.resize();
      });
    }
    else {
      colorVariantSelector.classList.add('flickity-disabled')
    }
      
    var variantInfo = parentElement.querySelector('.variant__label-info');
    var variantInfoSpan = variantInfo.querySelector('span');
    variantInfo.innerText = "";
    variantInfo.appendChild(
      variantInfoSpan
    );
    parentElement.querySelector('.product-block--header').appendChild(
      variantInfo
    );
  }
}
intiColorVariantSelector(document);

function intiProductQuantityStock(parentElement) {
  var productSalesPoint = parentElement.querySelector('.product-block.product-block--sales-point');
  if (productSalesPoint != null) {
    var productQuantityWrap = parentElement.querySelector('.product-block .product__quantity').parentNode;

    productSalesPoint.classList.remove('product-block');
    productQuantityWrap.appendChild(
          productSalesPoint
    );
  }
}
intiProductQuantityStock(document);

document.querySelectorAll('.product-block--tab .collapsible-content__inner.rte p').forEach(function(p, index) {
  if (p.textContent == '') {
    p.remove();
  }
});

function displayAmountOnCartBtn(parentElement) {
  if (parentElement == null) {
    return;
  }
  
  var money = parentElement.querySelectorAll('.product-block .product__price .money');
  if (money.length == 0) {
    setTimeout(function() {
      displayAmountOnCartBtn(parentElement)
    }, 500);
    return;
  }
  
  money = money[money.length - 1];
  
  var currency = money.textContent.replace(/[0-9\.\,]+/g,"");
  var amount = parseFloat(money.textContent.replace(/[^0-9\.-]+/g,""));
  
  if (!isNaN(amount)) {
    var qtyNum = parentElement.querySelector(".js-qty__num");
    var totalAmount = amount * parseInt(qtyNum.value);
    var cartBtn = parentElement.querySelector(".product-block .add-to-cart");

    var cartBtnMoney = cartBtn.querySelector(".add-to-cart-money");
    if (cartBtnMoney == null) {
      cartBtnMoney = document.createElement('span');
      cartBtnMoney.classList.add('add-to-cart-money');
      cartBtn.appendChild(cartBtnMoney);
    }
    
    var setBtnAmount = function() {
      var totalAcount = amount * parseInt(qtyNum.value);
      if (totalAcount % 1 !== 0) {
        totalAcount = totalAcount.toFixed(2);
      }
      cartBtnMoney.innerText = ': '+ currency + totalAcount;
    }
    
    setBtnAmount();
    
    setTimeout(function() {
      setBtnAmount();
      qtyNum.addEventListener('input', setBtnAmount);
      parentElement.querySelector(".js-qty__adjust--minus").addEventListener('click', setBtnAmount);
      parentElement.querySelector(".js-qty__adjust--plus").addEventListener('click', setBtnAmount);

    }, 1000);    
  }
}


function updateCartBtn(parentElement) {
  if (parentElement == null) {
    return;
  }
  
  var setClass = function(element) {
    setTimeout(function() {
        var cartBtn = element.closest('.product-single__meta').querySelector('.btn.add-to-cart');
        if (inventories[ShopifyAnalytics.meta.product.id][ShopifyAnalytics.meta.selectedVariantId] != undefined
            && inventories[ShopifyAnalytics.meta.product.id][ShopifyAnalytics.meta.selectedVariantId].preorder == 'true') {
          cartBtn.classList.add('preorder');
        }
        else {
          cartBtn.classList.remove('preorder');
        }
    }, 500);
  }
  
  parentElement.querySelectorAll('.variant-input').forEach(function(variantInput, index) {
    variantInput.addEventListener('click', function(event) {
      setClass(event.target);
      setTimeout(function() {
        displayAmountOnCartBtn(parentElement);
      }, 500); 
    });
  });
  
  setTimeout(function() {
    setClass(parentElement.querySelector('.variant-input'));
  }, 500);
  displayAmountOnCartBtn(parentElement);
}
updateCartBtn(document.querySelector('.product-section[data-product-id]'));

var productMeta = document.querySelector('.product-single__meta');
if (productMeta != null) {
  var setProductMetaTop = function() {
    var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    if (productMeta.clientHeight > vh) {
      productMeta.style.top = (vh - productMeta.clientHeight) + 'px';
    }
    else {
      productMeta.style.top = '';
    }
  };
  document.addEventListener('scroll', setProductMetaTop);
}

/* ==== Product collection page ==== */

document.querySelector('#MainContent').parentElement.addEventListener('mousemove', function(event) {
  var element = event.target;
  if (element.classList.contains('quick-product__btn')) {
    if (element.dataset.variantInit != 1) {
      element.dataset.variantInit = 1;

      var productItem = event.target.closest('.grid__item[data-variant-color], .grid-overflow-wrapper .grid__item.grid-product');
      if (productItem != null) {
        if (productItem.querySelector('img[alt]') != null) {
 
          element.addEventListener('click', function(event) {
            var waitCount = 100;

            var selectVarient = function() {
              var variantModel = document.querySelector('#QuickShopModal-'+ productItem.dataset.productId);
              if (waitCount-- && variantModel.querySelector('.variant-input-wrap[data-handle="color"] input:checked') == null) {
                setTimeout(selectVarient, 500);
                return;
              }

              // Required variant image donot displayed then try again
              var cardImgAlt = productItem.querySelector('img[alt]').alt;

              // Click on variant button to display required variant image
              var variantButton = variantModel.querySelector('.variant__button-label[data-variant-image-alt="'+ cardImgAlt +'"]');
              if (variantButton != null) {
                variantButton.click();

                variantModel.querySelector('.product__thumb img[alt="'+ cardImgAlt +'"]').parentNode.click();
              }

              intiColorVariantSelector(variantModel);
              intiProductQuantityStock(variantModel);
              updateCartBtn(variantModel);
            }

            selectVarient();
          });
        }
        
      }
    }
  }
});


/* ==== Hero Slideshow ==== */

var heroSlideshowInit = function() {
	var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	if (vw < 500) {
		document.querySelectorAll('.slideshow-wrapper').forEach(function(slideshow) {
			var textHeight = 0;
			slideshow.querySelectorAll('.hero__text-shadow').forEach(function(heroText) {
				if (textHeight < heroText.clientHeight) {
					textHeight = heroText.clientHeight;
				}
			});
			
			if (!(vw / 3 < textHeight)) {
				textHeight = 0;
			}
      
			var heroMobile = slideshow.querySelectorAll('[class*=hero-natural-mobile--template--');
			if (heroMobile.length) {
				heroMobile.forEach(function(div) {
					div.style.setProperty('padding-bottom', 'calc(100% + '+ (textHeight ? textHeight + 50 : 0)  +'px)');
				});
			}
		});
	}
};

window.addEventListener('load', heroSlideshowInit);
window.addEventListener('resize', heroSlideshowInit);


/* === Set image background to transparent === */

document.querySelectorAll('.image-wrap img').forEach(function(img) {
  if (img.complete) {
    img.parentElement.classList.add('bg-transparent');
  } else {
    img.addEventListener('load', function(event) {
      event.target.parentElement.classList.add('bg-transparent');
    });
  }
});


/* ==== Visual Q&A Gallery ==== */

window.addEventListener('load', function() {
  var selectVisualQA = document.getElementById('VisualQA');

  if (selectVisualQA !== null) {
    var selectPhotographer = document.getElementById('ArticlesPhotographer');
    var galleryContiner = document.getElementById('GalleryVisualQA');
    
    var photographerUrls = {};
    selectPhotographer.childNodes.forEach(el => {
        photographerUrls[el.textContent || el.innerText] = el.getAttribute('value');
    });
    
    selectVisualQA.addEventListener('change', function(event) {
      galleryContiner.innerHTML = '';
      
      if (qaImages == undefined || qaImages == null) {
        return;
      }

      var element = event.target;
      if (element.value == '') {
        //document.getElementById('ArticlesGrid').style.display = "block";
        window.location = '';
        return;
      }
      else if (qaImages.length) {
        document.getElementById('ArticlesGrid').style.display = "none";
        document.querySelector('.pagination').style.display = "none";
        window.location.hash = '#'+ element.value;
      }
      else {
        window.location = window.location.toString().split("?")[0] +'#'+ element.value;
        return;
      }
      
      
      var collectionLabel = '';
      document.querySelectorAll('#VisualQA option').forEach(function(option) {
        if(option.selected) {
          collectionLabel = ' - '+ option.innerHTML;
        }
      });
      
      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

      for (var i = 0; i < qaImages.length; i++) {
        if (qaImages[i].questions[element.value] !== undefined && qaImages[i].questions[element.value] !== null) {
          var imgSrc = qaImages[i].questions[element.value];
          var imgMatches = imgSrc.match(/_[^_.]+\./g);
          var imgAspect = imgMatches[imgMatches.length - 1];
          galleryContiner.insertAdjacentHTML('beforeend', '<a href="'+ imgSrc.replace(imgAspect, '_'+ vw +'x'+ vh +'.') +'" data-lightbox="'+ element.value +'" data-title="<a href=\''+ photographerUrls[qaImages[i].title] +'\'>'+ qaImages[i].title +'</a>'+ collectionLabel +'"><img src="'+ imgSrc.replace(imgAspect, '_large.') +'" alt="'+ qaImages[i].title +'" /></a>');
        }
      }
      
      $("#GalleryVisualQA").justifiedGallery({
        rowHeight : 300
      }).on('jg.complete', function () {
	    lightbox.option({
          resizeDuration: 200,
          wrapAround: true
        })
      });
      
      
    });
    
    var changeSelection = function() {      
      // Select Visual QA value from URL hash
      var selectedValue = window.location.hash.replace('#', '');
      if (selectVisualQA.value != selectedValue || (galleryContiner.innerHTML == '' && selectVisualQA.value != '')) {
        selectVisualQA.value = selectedValue;

        if ("createEvent" in document) {
          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          selectVisualQA.dispatchEvent(evt);
        }
        else {
          selectVisualQA.fireEvent("onchange");
        }      
      }
    }
    changeSelection();
    window.addEventListener('hashchange', changeSelection);

    selectPhotographer.value = '';
    selectPhotographer.addEventListener('change', function(event) {
      var url = event.target.value;
      if (url != '') {
        window.location = event.target.value;
      }
    });
  }
});


/* ==== Product variant same color bundle (like helioflex backpack) ==== */

window.addEventListener('load', function() {

	if (document.querySelector('.bundle-same-color') !== null) {
		document.querySelector('.bundle-same-color .variant-input-wrap').querySelectorAll('.variant-input').forEach(variantInput => {
			variantInput.querySelector('label').addEventListener("click", function (e) {
			  	document.querySelectorAll('.variant-input[data-value="'+ variantInput.dataset.value +'"] label').forEach((item, index, arr) => {
					if (index > 0) {
				        item.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true}));
				    }
				});
			});

		});
	}

});
